import apiClient from "@/api/client";
import type {
  SelfAllocationActionCount,
  SelfAllocationAvailableProject,
  SelfAllocationAvailableProjectGroup,
  SelfAllocationCreatePayload,
  SelfAllocationEligibility,
  SelfAllocationMissingRow,
  SelfAllocationRequest,
  SelfAllocationUpdatePayload,
} from "../types/selfAllocation";

const BASE = "/finances/self-allocation-requests";

export const selfAllocationApi = {
  list: (params?: Record<string, string | number | undefined>) =>
    apiClient
      .get<{ data: SelfAllocationRequest[]; meta: { count: number } }>(`${BASE}/`, { params })
      .then((r) => r.data),

  get: (id: string) =>
    apiClient
      .get<{ data: SelfAllocationRequest }>(`${BASE}/${id}/`)
      .then((r) => r.data.data),

  create: (data: SelfAllocationCreatePayload) =>
    apiClient
      .post<{ data: SelfAllocationRequest }>(`${BASE}/`, data)
      .then((r) => r.data.data),

  update: (id: string, data: SelfAllocationUpdatePayload) =>
    apiClient
      .patch<{ data: SelfAllocationRequest }>(`${BASE}/${id}/`, data)
      .then((r) => r.data.data),

  remove: (id: string) => apiClient.delete(`${BASE}/${id}/`),

  submit: (id: string) =>
    apiClient
      .post<{ data: SelfAllocationRequest }>(`${BASE}/${id}/submit/`)
      .then((r) => r.data.data),

  approve: (id: string) =>
    apiClient
      .post<{ data: SelfAllocationRequest }>(`${BASE}/${id}/approve/`)
      .then((r) => r.data.data),

  reject: (id: string, rejection_reason: string) =>
    apiClient
      .post<{ data: SelfAllocationRequest }>(`${BASE}/${id}/reject/`, { rejection_reason })
      .then((r) => r.data.data),

  eligibility: () =>
    apiClient
      .get<{ data: SelfAllocationEligibility }>(`${BASE}/eligibility/`)
      .then((r) => r.data.data),

  availableProjects: (id: string) =>
    apiClient
      .get<{ data: SelfAllocationAvailableProject[] }>(`${BASE}/${id}/available-projects/`)
      .then((r) => r.data.data),

  availableProjectGroups: (id: string) =>
    apiClient
      .get<{ data: SelfAllocationAvailableProjectGroup[] }>(
        `${BASE}/${id}/available-project-groups/`,
      )
      .then((r) => r.data.data),

  actionCount: () =>
    apiClient
      .get<{ data: SelfAllocationActionCount }>(`${BASE}/action-count/`)
      .then((r) => r.data.data.count),

  missing: (year: number, month: number) =>
    apiClient
      .get<{
        data: SelfAllocationMissingRow[];
        meta: { count: number; year: number; month: number };
      }>(`${BASE}/missing/`, { params: { year, month } })
      .then((r) => r.data),
};
